/*
=========================================================
* RingOperator Live Call Board — "Every call, handled."
=========================================================
*/

import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import { brandPrimary, brandCard, brandAccent, accentError } from "pages/RingOperatorHomepage/theme";

const line = "rgba(14,13,11,0.1)";
const muted = "rgba(14,13,11,0.55)";

function LiveBoard() {
  const calls = [
    { time: "NOW", caller: "Jessie M.", need: "AC tune-up", lang: "EN", outcome: "Booked Thu 10am", color: brandAccent, live: true },
    { time: "2m", caller: "Rafael S.", need: "Quote · water heater", lang: "ES", outcome: "Quote emailed", color: brandPrimary },
    { time: "7m", caller: "Priya K.", need: "Reschedule", lang: "EN", outcome: "Moved to Fri 3pm", color: brandPrimary },
    { time: "14m", caller: "(unknown)", need: "After-hours emergency", lang: "EN", outcome: "Transferred to on-call", color: accentError },
    { time: "22m", caller: "Maya L.", need: "FAQ · service area", lang: "EN", outcome: "Answered", color: brandPrimary },
  ];

  const grid = "80px 1.2fr 1.6fr 70px 1.4fr 110px";

  return (
    <MKBox component="section" className="ro-root" sx={{ py: { xs: 8, md: 12 }, background: "#F4F1EA" }}>
      <Container>
        <MKBox
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            mb: 4.5,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <MKTypography
            component="h2"
            sx={{
              m: 0,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3.75rem" },
              lineHeight: 1,
              letterSpacing: "-0.03em",
              fontWeight: 800,
              color: brandPrimary,
            }}
          >
            Every call,{" "}
            <MKBox component="span" className="ro-serif" sx={{ fontStyle: "italic" }}>
              handled.
            </MKBox>
          </MKTypography>
          <MKBox
            className="ro-mono"
            sx={{ fontSize: 12, color: muted, textTransform: "uppercase", letterSpacing: "0.1em" }}
          >
            sample dashboard · what your feed looks like
          </MKBox>
        </MKBox>

        <MKBox
          sx={{
            background: brandCard,
            border: `1px solid ${line}`,
            borderRadius: 3,
            overflow: "hidden",
          }}
        >
          <MKBox
            className="ro-mono"
            sx={{
              display: { xs: "none", md: "grid" },
              gridTemplateColumns: grid,
              px: 3,
              py: 2,
              borderBottom: `1px solid ${line}`,
              fontSize: 11,
              color: muted,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
            }}
          >
            <span>Time</span>
            <span>Caller</span>
            <span>Intent</span>
            <span>Lang</span>
            <span>Outcome</span>
            <span style={{ textAlign: "right" }}>Status</span>
          </MKBox>

          {calls.map((c, i) => (
            <MKBox
              key={i}
              sx={{
                display: { xs: "block", md: "grid" },
                gridTemplateColumns: grid,
                alignItems: "center",
                px: 3,
                py: 2.25,
                borderBottom: i < calls.length - 1 ? `1px solid ${line}` : "none",
                fontSize: 15,
                background: i === 0 ? "rgba(14,13,11,0.02)" : "transparent",
              }}
            >
              <MKBox
                className="ro-mono"
                sx={{
                  fontSize: 13,
                  color: c.live ? c.color : muted,
                  fontWeight: c.live ? 700 : 500,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  mb: { xs: 0.5, md: 0 },
                }}
              >
                {c.live && (
                  <MKBox
                    component="span"
                    sx={{
                      display: "inline-block",
                      width: 6,
                      height: 6,
                      borderRadius: "50%",
                      background: c.color,
                      animation: "ro-pulse 1.4s ease-out infinite",
                    }}
                  />
                )}
                {c.time}
              </MKBox>
              <MKBox sx={{ fontWeight: 600, color: brandPrimary }}>{c.caller}</MKBox>
              <MKBox sx={{ color: brandPrimary }}>{c.need}</MKBox>
              <MKBox
                className="ro-mono"
                sx={{ fontSize: 12, color: muted, display: { xs: "none", md: "block" } }}
              >
                {c.lang}
              </MKBox>
              <MKBox sx={{ color: brandPrimary }}>{c.outcome}</MKBox>
              <MKBox sx={{ textAlign: { xs: "left", md: "right" }, mt: { xs: 0.75, md: 0 } }}>
                <MKBox
                  component="span"
                  sx={{
                    display: "inline-block",
                    px: 1.25,
                    py: 0.5,
                    borderRadius: 999,
                    background: "rgba(14,13,11,0.06)",
                    color: c.color,
                    fontSize: 12,
                    fontWeight: 600,
                  }}
                >
                  ● done
                </MKBox>
              </MKBox>
            </MKBox>
          ))}
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default LiveBoard;
